import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addItemDropdown: 'Add a product or service',
    addItemSimple: 'Add another item',
    fromCatalog: {
      description: 'Import an item into your catalogue',
      title: ' Add from the catalogue',
    },
    oneOff: {
      description: 'Fill in your information',
      title: 'Add a one-off item',
    },
  },
  fr: {
    addItemDropdown: 'Ajouter un nouveau produit ou service',
    addItemSimple: 'Ajouter un autre élément',
    fromCatalog: {
      description: 'Importer un article dans votre catalogue',
      title: 'Ajouter depuis le catalogue',
    },
    oneOff: {
      description: 'Renseigner vous même vos informations',
      title: 'Ajouter un article ponctuel',
    },
  },
} as const);

export default locales;
